import { DOMUtils } from '../../../../utils/dom'
import { IdentityEvent } from '../../../common/events/identity'
import { IProfile } from '../../../common/profile'
import { IAnalyticsProviderConfig } from '../adapter'

import { SetAttributes } from '../../../../domain/analytics/providers/mparticle/events/user/set-attributes'

import { Debug } from '../../../../utils/debug'

export interface IWindow extends Window {
    mParticle: any
}

declare let window: IWindow

export class MParticle {
    /**
     * initialize mParticle
     *
     * TODO: isDevelopmentMode from configuration object
     * isDevelopmentMode: false (or removed) from production
     *
     * identifyRequest: IDSync request, contains desired indentify
     * request. mParticle will use recent/previous indentities if
     * not provided
     * https://docs.mparticle.com/developers/sdk/web/idsync/
     *
     * identityCallback: get executed on successfull completion of
     * IDSync. Provides mParticle init information
     */
    public initialize(
        creds: IAnalyticsProviderConfig,
        profile: IProfile,
        meta: object): void {

        const identityRequest = {
            userIdentities: {
                customerid: profile.uuid ? String(profile.uuid) : '',
                email: profile.email ? String(profile.email) : ''
            }
        }

        const config = {
            appVersion: '1.0.0',
            customFlags: {},
            identifyRequest: identityRequest,
            identityCallback: this.mParticleCallback.bind(this, profile, meta),
            isDebug: true,
            isDevelopmentMode: creds.isDev,
            isSandbox: true,
            sessionTimeout: 30,
            useCookieStorage: true,
            useNativeSdk: false,
        }

        // setup global object and queue
        window.mParticle = window.mParticle || { config: { rq: [] } }
        window.mParticle.config = { ...window.mParticle.config, ...config }
        window.mParticle.ready = (f: () => void) => window.mParticle.config.rq.push(f)

        // load JS
        DOMUtils.loadScript(`//jssdkcdns.mparticle.com/js/v2/${creds.account}/mparticle.js`)

    }

    /**
     * mParticle init callback
     */
    public mParticleCallback(profile: IProfile, meta: any, result: any) {
        const currentIdentities: any = result.getUser().getUserIdentities().userIdentities
        if (
            currentIdentities.other2 !== localStorage.getItem('globalmParticleCookieID')
            || null !== JSON.parse(localStorage.getItem('janrainCaptureProfileData'))
        ) {
            const identityObject: any = {}
            identityObject.userIdentities = {}
            if (currentIdentities.other2 !== localStorage.getItem('globalmParticleCookieID')) {
                identityObject.userIdentities.other2 = String(localStorage.getItem('globalmParticleCookieID'))
            }
            if (null !== JSON.parse(localStorage.getItem('janrainCaptureProfileData'))) {
                identityObject.userIdentities.customerid =
                    JSON.parse(localStorage.getItem('janrainCaptureProfileData')).uuid
                identityObject.userIdentities.email =
                    JSON.parse(localStorage.getItem('janrainCaptureProfileData')).email
            }
            window.mParticle.Identity.identify(identityObject, () => {
                // still need to handle the user events
                SetAttributes(result, profile, meta)
            })
        }

        /**
         * Implement mParticle debug for QA should append
         * mParticle Id and device Id to be body
         */
        const debug = new Debug()
        debug.display()

        /**
         * Dispatcing mParticle Id as soon as it becomes available
         */
        if (window.mParticle.Identity.getCurrentUser().getMPID()) {
            dispatchEvent(new CustomEvent(IdentityEvent.PROVIDER_ID_ASSIGNED, {
                detail: { mpId: window.mParticle.Identity.getCurrentUser().getMPID() }
            }))
        }

        /**
         * Dispatching mParticle Session UUID as soon as it becomes available
         */
        if (window.mParticle) {
            dispatchEvent(new CustomEvent(IdentityEvent.MP_READY, {
                detail: {
                    mpId: window.mParticle.Identity.getCurrentUser().getMPID(),
                    mpSessionUuid: window.mParticle.sessionManager.getSession()
                }
            }))
        }
    }

}
